import { Button, Card, Dialog, DialogContent, DialogTitle, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useHistory } from 'react-router'
import { useQuery } from 'react-query'
import { CoachCampAPI } from '../../../utils/api'
import { useFeedback } from '../../../components/Feedback'
import ShareConfigDialog from '../../../components/ShareConfigDialog'

const CoachCampList = () => {
    const history = useHistory()
    const { showToast } = useFeedback()
    const [camp, setCamp] = useState<CoachCamp | null>(null)
    const [configKey, setConfigKey] = useState<string>()
    const { data, refetch } = useQuery(['list', camp?.id], () => camp && CoachCampAPI.listEnrollmentsByCampId(camp.id), { enabled: false })
    const { data: campsResult, refetch: refetchCamps } = useQuery(['listCoachCamps'], () => CoachCampAPI.list())
    useEffect(() => {
        if (camp) {
            refetch()
        }
    }, [camp])

    const handleStatusChange = (id: number) => (event: React.ChangeEvent<{ value: unknown }>) => {
        CoachCampAPI.update(id, { is_enable: event.target.value as number }).then(res => {
            refetchCamps()
        }).catch(err => {
            showToast('修改失败')
            refetchCamps()
        })
    }

    return <React.Fragment>
        <Card>
            <TableContainer style={{ overflowX: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>名称</TableCell>
                            <TableCell>时间</TableCell>
                            <TableCell align="center">费用</TableCell>
                            <TableCell align="center">报名人数</TableCell>
                            <TableCell align="center">总收入</TableCell>
                            <TableCell align="center">上线状态</TableCell>
                            <TableCell align="center">操作</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {campsResult?.data?.map((camp: CoachCamp) => <TableRow key={camp.id}>
                            <TableCell >{camp.name}</TableCell>
                            <TableCell>{moment(camp.begin_time).format('YYYY/MM/DD')} 至 {moment(camp.end_time).format('YYYY/MM/DD')}</TableCell>
                            <TableCell align="center">{camp.price}元</TableCell>
                            <TableCell align="center"><Button onClick={() => setCamp(camp)} variant="text">{camp.number_of_enrollments}/{camp.max_enrollment_number}</Button></TableCell>
                            <TableCell align="center">{camp.number_of_enrollments * camp.price}元</TableCell>
                            <TableCell align="center">
                                <Select style={{ backgroundColor: `${camp.is_enable ? '#fff' : '#d1d1d1'}` }} onChange={handleStatusChange(camp.id)} value={camp.is_enable}>
                                    <MenuItem value="1">上线</MenuItem>
                                    <MenuItem value="0">下线</MenuItem>
                                </Select>
                            </TableCell>
                            <TableCell align="center">
                                <Button size="small" onClick={() => history.push(`/admin/coach-camp/edit/${camp.id}`)}>编辑</Button>
                                <Button size="small" style={{ marginLeft: '8px' }} onClick={() => setConfigKey(camp.id)}>分享设置</Button>
                            </TableCell>
                        </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
        <ShareConfigDialog type="coach_camp" typeKey={configKey} open={Boolean(configKey)} onClose={(save?: boolean) => {
            if (save) {
                refetch()
            }
            setConfigKey(undefined)
        }} />
        <Dialog maxWidth="md" open={!!camp} fullWidth onClose={() => setCamp(null)}>
            <DialogTitle>
                报名列表
            </DialogTitle>
            <DialogContent>
                <TableContainer style={{ overflowX: 'auto' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>姓名</TableCell>
                                <TableCell>手机号</TableCell>
                                <TableCell>报名时间</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.data.map((enrollment: any) => <TableRow key={enrollment.id}>
                                <TableCell>{enrollment.user.name}</TableCell>
                                <TableCell>{`+${enrollment.user.national_code}${enrollment.user.mobile}`}</TableCell>
                                <TableCell>{moment(enrollment.create_time).format('YYYY-MM-DD HH:mm')}</TableCell>
                            </TableRow>)}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>

    </React.Fragment>
}

export default CoachCampList